var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tls-popup--body-slot" }, [
      _vm.tmaData.length > 0 && _vm.formId
        ? _c("div", { staticClass: "tls-action-status-info" }, [
            _c("div", { staticClass: "tls-action-status-info-card" }, [
              _c("div", {
                staticClass: "tls-validated-action-status--icon -color-green"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tls-action-status-info-text" }, [
                _vm._v(_vm._s(_vm._.get(_vm.cmsData, "status_done")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-action-status-info-card" }, [
              _c("div", {
                staticClass: "tls-validated-action-status--icon -color-grey"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tls-action-status-info-text" }, [
                _vm._v(_vm._s(_vm._.get(_vm.cmsData, "status_undone")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-action-status-info-card" }, [
              _c("div", {
                staticClass: "tls-validated-action-status--icon -color-red"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tls-action-status-info-text" }, [
                _vm._v(_vm._s(_vm._.get(_vm.cmsData, "status_attention")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-action-status-info-card" }, [
              _c("div", {
                staticClass: "tls-validated-action-status--icon -color-yellow"
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tls-action-status-info-text" }, [
                _vm._v(_vm._s(_vm._.get(_vm.cmsData, "status_pending")))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.tmaData.length > 0 && _vm.formId
        ? _c(
            "div",
            { staticClass: "tls-action-status-group" },
            _vm._l(_vm.tmaData, function(step) {
              return step.visible
                ? _c("div", { staticClass: "tls-action-status-group--slot" }, [
                    _c("div", { staticClass: "tls-validated-action-status" }, [
                      _c("div", {
                        staticClass: "tls-validated-action-status--icon",
                        class: _vm.getTMAStatus(step.status)
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tls-validated-action-status--text",
                          class: _vm.getTMAStatus(step.status)
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getTMATranslate(step.name)) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      step.name.indexOf("decision_made") !== -1 &&
                      step.status === "sent"
                        ? _c(
                            "div",
                            { staticClass: "tls-validated-decision-made-text" },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._.get(_vm.cmsData, "instruction_alert")
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }